import { ChangeEvent, FC } from 'react';
import cx from 'classnames/bind';
import { motion, AnimatePresence } from 'framer-motion';

import Cursor from '@/assets/cursor.svg';

import styles from './Switch.module.scss';

const cn = cx.bind(styles);

interface SwitchProps {
  setIsShowCheckboxes: (value: boolean) => void;
  handleClick?: () => void;
  resetCheckboxes: () => void;
  cursor?: string;
  setCursor?: (value: string) => void;
  firstPlay?: boolean;
}

const Switch: FC<SwitchProps> = ({
  setIsShowCheckboxes,
  handleClick,
  resetCheckboxes,
  cursor,
  setCursor,
  firstPlay,
}) => {
  const toggleSwitch = (e: ChangeEvent<HTMLInputElement>) => {
    setIsShowCheckboxes(e.target.checked);

    if (handleClick) {
      handleClick();
    }

    if (!e.target.checked) {
      resetCheckboxes();
    }
  };

  return (
    <label className={cn('switch')}>
      <input
        className={cn('switch-input')}
        onChange={(e) => toggleSwitch(e)}
        type="checkbox"
      />
      <span className={cn('slider')} />

      <AnimatePresence>
        {cursor === 'cursor2' && !firstPlay && (
          <motion.img
            initial={{ x: 0, opacity: 1 }}
            animate={{ x: -15, opacity: 1 }}
            transition={{
              duration: 0.6,
              repeat: 3,
              repeatType: 'mirror',
            }}
            onAnimationComplete={() => {
              if (setCursor) {
                setCursor('');
              }
            }}
            src={Cursor}
            alt="Курсор"
            className={cn('cursor')}
          />
        )}
      </AnimatePresence>
    </label>
  );
};

export default Switch;
